const GET_USER_DATA = 'GET_USER_DATA';
const SET_USER_DATA  = 'SET_USER_DATA';
const GET_PRE_USER_DATA = 'GET_PRE_USER_DATA';
const SET_PRE_USER_DATA = 'SET_PRE_USER_DATA';
const GET_USER_INFO = 'GET_USER_INFO';
const SET_USER_INFO = 'SET_USER_INFO';
const GET_INVOICE_DATA = 'GET_INVOICE_DATA';
const SET_INVOICE_DATA = 'SET_INVOICE_DATA';
const GET_ROLE_DATA = 'GET_ROLE_DATA';
const SET_ROLE_DATA = 'SET_ROLE_DATA';


const getInvoiceData = id =>{
    return {
        type:GET_INVOICE_DATA,
        id
    }
}

const setInvoiceData = data =>{
    return {
        type: SET_INVOICE_DATA,
        data
    }
}
const getUserData = query => {
    return {
        type: GET_USER_DATA,
        query
    };
}

const setUserData = data => {
    return {
        type: SET_USER_DATA,
        data
    };
}

const getPreUserData = email => {
    return {
        type: GET_PRE_USER_DATA,
        email
    };
}

const setPreUserData = data => {
    return {
        type: SET_PRE_USER_DATA,
        data
    };
}

const getUserInfo = email => {
    return {
        type: GET_USER_INFO,
        email
    };
}

const setUserInfo = data => {
    return {
        type: SET_USER_INFO,
        data
    };
}

const setRoleData = data => {
    return {
        type: SET_ROLE_DATA,
        data
    };
}

const getRoleData = () => {
    return {
        type: GET_ROLE_DATA,
    };
}

export default {
    types: {
        SET_USER_DATA,
        GET_USER_DATA,
        GET_PRE_USER_DATA,
        SET_PRE_USER_DATA,
        GET_USER_INFO,
        SET_USER_INFO,
        GET_INVOICE_DATA,
        SET_INVOICE_DATA,
        SET_ROLE_DATA,
        GET_ROLE_DATA
    },    
    actions: {
        getUserData,
        setUserData,
        getPreUserData,
        setPreUserData,
        getUserInfo,
        setUserInfo,
        getInvoiceData,
        setInvoiceData,
        setRoleData,
        getRoleData
    }
}